import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { isOS } from '../../../client'
import { ICategoryTreeItem } from '../../../types'
import {
  EmptyDataContainer,
  SearchContainer,
} from '../KalturaSearchComponent/KalturaSearchComponent.style'
import { MainRailPage } from '../MainRailPage/MainRailPage'
import { useOttStore } from '../../store/ottStore'
import { RailSearch } from '../Rail_Search/RailSearch'
import { he } from '../../../locales/he'

interface KalturaSearchComponentProps {
  railsData: ICategoryTreeItem
}

const minCharsToSearch = 2
const SearchView: React.FC<KalturaSearchComponentProps> = ({ railsData }) => {
  const [searchQuery, setSearchQuery] = useOttStore(state => [
    state.searchQuery,
    state.setSearchQuery,
  ])
  const [query, setQuery] = useState('')
  const [emptyEpisodesData, setEmptyEpisodesData] = useState(false)
  const [emptyShowsData, setEmptyShowsData] = useState(false)
  const [emptyMoviesData, setEmptyMoviesData] = useState(false)
  const typingTimeout = useRef<null | NodeJS.Timeout>(null)
  const [ios, setIos] = useState(0)
  useEffect(() => {
    setIos(isOS() ? 1 : 0)
  }, [])
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
    if (typingTimeout.current) {
      clearTimeout(typingTimeout.current)
    }
    typingTimeout.current = setTimeout(
      () => setSearchQuery(event.target.value),
      300
    )
  }

  const handleClearSearch = () => {
    setSearchQuery('')
    setQuery('')
  }

  useEffect(() => {
    setSearchQuery('')
    setQuery('')
  }, [setSearchQuery])

  return (
    <>
      <SearchContainer paddingTop={ios}>
        <div>
          <label>
            <input
              type='text'
              value={query}
              onChange={handleSearchChange}
              placeholder='חיפוש תוכניות או פרקים'
            />
            {searchQuery && <span onClick={handleClearSearch}>✕</span>}
          </label>
        </div>
      </SearchContainer>
      {searchQuery.length >= minCharsToSearch ? (
        <>
          {emptyEpisodesData && emptyShowsData && emptyMoviesData && (
            <>
              <EmptyDataContainer>
                {[he.noResults, `"${searchQuery}"`].join(' ')}
              </EmptyDataContainer>
              {railsData?.children.map(rail => (
                <MainRailPage data={rail} key={rail.id} />
              ))}
            </>
          )}
          <RailSearch
            key={'RailSearchEpisodes'}
            railType='episodes'
            isEmptyData={setEmptyEpisodesData}
          />
          <RailSearch
            key={'RailSearchShows'}
            railType='shows'
            isEmptyData={setEmptyShowsData}
          />
          <RailSearch
            key={'RailSearchMovies'}
            railType='movies'
            isEmptyData={setEmptyMoviesData}
          />
        </>
      ) : (
        railsData?.children.map(rail => (
          <MainRailPage data={rail} key={rail.id} />
        ))
      )}
    </>
  )
}
export default SearchView
